import { render, staticRenderFns } from "./EventTicketTabTemplate.vue?vue&type=template&id=76e8ed72&scoped=true"
import script from "./EventTicketTabTemplate.vue?vue&type=script&lang=js"
export * from "./EventTicketTabTemplate.vue?vue&type=script&lang=js"
import style0 from "./EventTicketTabTemplate.vue?vue&type=style&index=0&id=76e8ed72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8ed72",
  null
  
)

export default component.exports